module.exports = __webpack_public_path__ + "static/media/my-info-menu-icon.83d1e07d.svg";